import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SITE } from "../lib/site";

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    return (
        <header
            data-testid="site-navbar"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled ? "bg-bone/80 backdrop-blur-xl border-b border-line" : "bg-transparent border-b border-transparent"
            }`}
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
                <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
                    <span className="w-8 h-8 border border-forest flex items-center justify-center">
                        <span className="font-serif text-forest text-lg leading-none">S</span>
                    </span>
                    <div className="leading-tight">
                        <div className="font-serif text-forest text-xl tracking-tight">Shaurya</div>
                        <div className="text-[10px] uppercase tracking-widest2 text-charcoal/60 -mt-0.5">Polymers</div>
                    </div>
                </Link>

                <nav className="hidden lg:flex items-center gap-10">
                    {SITE.nav.map((item) => (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            data-testid={`nav-link-${item.label.toLowerCase()}`}
                            end={item.to === "/"}
                            className={({ isActive }) =>
                                `text-sm tracking-wide underline-grow ${
                                    isActive ? "text-forest font-medium" : "text-charcoal/70 hover:text-forest"
                                }`
                            }
                        >
                            {item.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="hidden lg:flex items-center gap-4">
                    <Link
                        to="/contact"
                        data-testid="nav-cta-quote"
                        className="group relative inline-flex items-center gap-2 px-5 py-2.5 border border-forest text-forest text-sm tracking-wide hover:bg-forest hover:text-bone transition-colors duration-500"
                    >
                        Request a Quote
                        <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
                    </Link>
                </div>

                <button
                    onClick={() => setOpen((s) => !s)}
                    aria-label="Toggle menu"
                    data-testid="nav-mobile-toggle"
                    className="lg:hidden text-forest p-2"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </div>

            {open && (
                <div data-testid="nav-mobile-panel" className="lg:hidden bg-bone border-t border-line">
                    <div className="px-6 py-6 flex flex-col gap-5">
                        {SITE.nav.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                end={item.to === "/"}
                                data-testid={`nav-mobile-link-${item.label.toLowerCase()}`}
                                className={({ isActive }) =>
                                    `font-serif text-3xl ${isActive ? "text-forest" : "text-charcoal/60"}`
                                }
                            >
                                {item.label}
                            </NavLink>
                        ))}
                        <Link
                            to="/contact"
                            data-testid="nav-mobile-cta"
                            className="mt-4 inline-flex w-fit items-center gap-2 px-5 py-3 border border-forest text-forest text-sm tracking-wide"
                        >
                            Request a Quote →
                        </Link>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Navbar;
